export default "__VITE_ASSET__dc04c008__"